import { useState } from 'react';
import { Modal, Input, message, theme } from 'antd';
import { useAnularCobro } from '../api/useCobros';
import { useT } from '../../../locales';

const { TextArea } = Input;

interface AnularCobroModalProps {
  open: boolean;
  cobroId: number;
  onClose: () => void;
  onSuccess?: () => void;
}

export function AnularCobroModal({ open, cobroId, onClose, onSuccess }: AnularCobroModalProps) {
  const t = useT();
  const { token } = theme.useToken();
  const [motivo, setMotivo] = useState('');
  const anular = useAnularCobro();
  const [error, setError] = useState<string | null>(null);

  const handleConfirm = async () => {
    if (!motivo.trim()) {
      setError(t('pages.cobros.anularMotivoRequerido'));
      return;
    }
    setError(null);
    try {
      await anular.mutateAsync({ id: cobroId, dto: { motivo: motivo.trim() } });
      message.success(t('pages.cobros.anularSuccess'));
      onSuccess?.();
      onClose();
    } catch {
      message.error(t('pages.cobros.anularError'));
    }
  };

  return (
    <Modal
      title={t('pages.cobros.anular')}
      open={open}
      onOk={handleConfirm}
      onCancel={onClose}
      confirmLoading={anular.isPending}
      okText={t('pages.cobros.anularOk')}
      okButtonProps={{ danger: true }}
      centered
      width={520}
      styles={{ body: { maxHeight: '70vh', overflowY: 'auto' } }}
    >
      <p>{t('pages.cobros.anularConfirm')}</p>
      <TextArea
        placeholder={t('pages.cobros.anularMotivoPlaceholder')}
        value={motivo}
        onChange={(e) => setMotivo(e.target.value)}
        rows={3}
        style={{ marginTop: 12 }}
      />
      {error && <p style={{ color: token.colorError, marginTop: 8 }}>{error}</p>}
    </Modal>
  );
}
